import { render, staticRenderFns } from "./CustomerAuditTrail.vue?vue&type=template&id=3c0c6481"
import script from "./CustomerAuditTrail.vue?vue&type=script&lang=js"
export * from "./CustomerAuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports